import React, { useEffect, useRef } from 'react';
import { SettingsTitle } from '../SettingsTitle';
import { SettingsDescription } from '../SettingsDescription';
import { Toggle } from '../../../common/toggle';
import useSpotConfig from '@host-panel/request/config/use-config';

interface SettingsFlagProps {
  title: string;
  description: string;
  path: string;
  onChange?: (value: boolean) => void;
  onFetched?: (value: boolean) => void;
}

export function SettingsFlag(props: SettingsFlagProps) {
  const { title, description, path, onChange, onFetched } = props;

  const notifyOnFetch = useRef(true);

  const [[value], setConfigs, { loading }] = (useSpotConfig([path], {
    [path]: false
  }) as unknown) as [[boolean], (value: unknown) => void, { loading: boolean }];

  const onInternalChange = (value: boolean) => {
    setConfigs({
      key: path,
      value
    });
  };

  useEffect(() => {
    if (!loading && notifyOnFetch.current) {
      onFetched?.(value);

      notifyOnFetch.current = false;
    }
  }, [loading, onFetched, value]);

  return (
    <>
      <SettingsTitle title={title} />
      <SettingsDescription description={description} />
      <Toggle checked={value} onChange={onChange || onInternalChange} />
    </>
  );
}
